"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var BackBtn_1 = require("../common/Btn/BackBtn");
var CloseBtn_1 = require("../common/Btn/CloseBtn");
var OpLogo_1 = require("../common/Logo/OpLogo");
var MenuBtn_1 = require("./MenuBtn");
var MenuContext_1 = require("./MenuContext");
var MenuHead = function (_a) {
    var subMenu = _a.subMenu;
    var _b = (0, hooks_1.useContext)(MenuContext_1.default), handleSlide = _b.handleSlide, setSubMenu = _b.setSubMenu;
    // if desktop, render larger OP logo
    var isDesktop = window.innerWidth >= 1025;
    return ((0, preact_1.h)("div", { class: 'menu-head' },
        (0, preact_1.h)("div", { class: 'menu-head__item menu-head__item--1' }, subMenu ? ((0, preact_1.h)(BackBtn_1.default, { onClick: function () { return setSubMenu(null); } })) : ((0, preact_1.h)(MenuBtn_1.default, { closeMenu: function () { return handleSlide(null); } }))),
        (0, preact_1.h)("div", { class: 'menu-head__item menu-head__item--2' },
            (0, preact_1.h)(OpLogo_1.default, { link: true, height: isDesktop ? 27 : 17 })),
        (0, preact_1.h)("div", { class: 'menu-head__item menu-head__item--3' },
            (0, preact_1.h)(CloseBtn_1.default, { closeFn: function () { return handleSlide(null); } }))));
};
exports.default = MenuHead;
